module.exports = require("@clairejs/core");